import { render } from "./ProductLogsList.vue?vue&type=template&id=28d3ce0d&scoped=true"
import script from "./ProductLogsList.vue?vue&type=script&lang=js"
export * from "./ProductLogsList.vue?vue&type=script&lang=js"

import "./ProductLogsList.vue?vue&type=style&index=0&id=28d3ce0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d3ce0d"]])

export default __exports__